import React from 'react'

import {
  Container,
  Row,
  Col,
} from 'reactstrap'

import SectionTitle from '../../components/sectionTitle';

function Privacy() {
  return(
    <Container fluid className="text-left">
      <Row className="bg-white pt-105">
        <Container>
          
        </Container>
      </Row>

      <Container className="text-left pb-5 terms-privacy">
        <SectionTitle title="Privacy Policy" color="black" />
        <Row>
          <Col>
            <p>This Privacy Policy governs the manner in which Complitech collects, uses, maintains and discloses information collected from users (each, a "User") of the website ("Site"). This privacy policy applies to the Site and all products and services offered by Complitech.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4>Personal identification information</h4>
            <p>We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, fill out a form, and in connection with other activities, services, features or resources we make available on our Site. Users may be asked for, as appropriate, name, email address, phone number. Users may, however, visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4>Non-personal identification information</h4>
            <p>We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4>How we use collected information</h4>
            <p>Complitech may collect and use Users personal information for the following purposes:</p>
            <ul>
              <li>To personalize user experience: We may use information in the aggregate to understand how our Users as a group use the services and resources provided on our Site.</li>
              <li>To send periodic emails: We may use the email address to respond to their inquiries, questions, and/or other requests. If User decides to opt-in to our mailing list, they will receive emails that may include company news, updates, related product or service information, etc. If at any time the User would like to unsubscribe from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email.</li>
            </ul>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4>How we protect your information</h4>
            <p>We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4>Sharing your personal information</h4>
            <p>We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above.We may use third party service providers to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys. We may share your information with these third parties for those limited purposes provided that you have given us your permission.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4>Changes to this privacy policy</h4>
            <p>Complitech has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4>Your acceptance of these terms</h4>
            <p>By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our Site. Your continued use of the Site following the posting of changes to this policy will be deemed your acceptance of those changes.</p>
          </Col>
        </Row>
      </Container>
    </Container>


  );
}

export default Privacy;